import { Component, OnInit } from '@angular/core';
import { FeaturedLiteratureService } from './service/featured-literature.service';
import { Observable, of } from 'rxjs';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { LiteratureDocument, LiteratureContentDocument } from '@types';
import { ResponsiveService } from '@frk/eds-components';
import { catchError } from 'rxjs/operators';
import { Logger } from '@utils/logger';
const logger = Logger.getLogger('FeaturedLiteratureComponent');
/**
 * featured literature page is configured at Bloomreach
 * will show all documents that are configured at part of featured literature
 */
@Component({
  selector: 'ft-featured-literature',
  templateUrl: './featured-literature.component.html',
  styleUrls: ['./featured-literature.component.scss'],
})
export class FeaturedLiteratureComponent
  extends AbstractBaseComponent
  implements OnInit {
  contentLiteratureList = [];
  LiteratureContentDocument: LiteratureContentDocument[];
  constructor(
    private featureService: FeaturedLiteratureService,
    private responsiveService: ResponsiveService
  ) {
    super();
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.isMobile$ = this.responsiveService.isMobile$();
  }
  data$: Observable<LiteratureDocument[]>;
  paramMap: Map<string, string>;
  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;

  ngOnInit(): void {
    this.paramMap = new Map();
    const content = this.document?.getData();
    if (content) {
      this.LiteratureContentDocument = content.literatureListContent?.map(
        (item) => {
          return {
            url: item.linkURL?.url,
            literatureCode: item.literatureCode,
            title: item.title,
            description: item.description?.value,
          };
        }
      );
      // fetches all litCodes from the featured-literature object from config
      const litCode = content.literatureListContent?.map(
        (item) => item.literatureCode
      );
      this.paramMap.set('literatureCode', litCode.toString());
      this.paramMap.set('cache', 'true');
      // populates documents based on fetched litCodes
      this.data$ = this.featureService
        .populate(this.paramMap, this.LiteratureContentDocument)
        .pipe(
          catchError((errorResponse) => {
            if (errorResponse?.status === 404) {
              logger.warn(
                '[populate]' +
                  errorResponse?.message +
                  ' code: ' +
                  errorResponse?.error?.message
              );
              return of({} as LiteratureDocument[]);
            }
          })
        );
    }
  }

  getDescription(description: string) {
    return `<p>${description}</p>`;
  }
}
